import { updateTexts } from './keyedCeasar';
import { centeredNotification } from './utility';
import Cookies from 'js-cookie';
import { COMMON_ERROR } from '../shared/constants/commonConstants';

const keyVar = process.env['REACT_APP_ENCRYPTION_KEY'] || '';
export const encryptText = (text: string): string => {
  if (process.env.REACT_APP_CURRENT_ENVIRONMENT === 'production' || process.env.REACT_APP_CURRENT_ENVIRONMENT === 'staging') {
    return text;
  }
  let encryptedText = text;
  try {
    encryptedText = btoa(
      updateTexts(
        { text: JSON.stringify(JSON.parse(text)), keyword: keyVar },
        false,
      ),
    );
  } catch (e) {
    centeredNotification(COMMON_ERROR, 'error', null, 5);
    return '{}';
  }
  return encryptedText;
};

export const decryptText = (text: string): string => {
  if (process.env.REACT_APP_CURRENT_ENVIRONMENT === 'production' || process.env.REACT_APP_CURRENT_ENVIRONMENT === 'staging') {
    return text;
  }
  let decryptedText = '';
  try {
    decryptedText =
      text === '{}'
        ? text
        : JSON.stringify(
            JSON.parse(updateTexts({ text: atob(text), keyword: keyVar }, true)),
          );
  } catch (e) {
    centeredNotification(
      'Error Occurred while logging you in,\n This happened because of new security update in the application, please login again.',
      'error',
      null,
      5,
    );
    localStorage.clear();
    Cookies.remove('r2_dto');
    setTimeout((): void => {
      window.location.pathname = '/';
    }, 5000);
  }
  return decryptedText;
};
